"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatCamelCaseToSentenceCase = void 0;
//e.g CamelCase --> Sentence Case
var formatCamelCaseToSentenceCase = function (text) {
    var toReturn = text.replace(/([a-z0-9])([A-Z])/g, '$1 $2');
    //picked up from here: https://stackoverflow.com/questions/18379254/regex-to-split-camel-case
    //explanation of $1 $2: https://stackoverflow.com/questions/16702924/how-to-explain-1-2-in-javascript-when-using-regular-expression
    return toReturn[0].toUpperCase() + toReturn.slice(1);
};
exports.formatCamelCaseToSentenceCase = formatCamelCaseToSentenceCase;
